import { toast } from "react-toastify";

import BulkAction from "common/components/BulkAction";
import type { WorkspaceAccount } from "common/types";

import AccountName from "./components/AccountName";
import AccountProfileImage from "./components/AccountProfileImage";

export function startAccountsBulkAction(
  actionFn: (accountId: string, abortSignal: AbortSignal) => Promise<void>,
  accounts: WorkspaceAccount[],
  renderToastTitle: (finishedItemsCount: number) => string,
  isAsync?: boolean,
) {
  toast(
    ({ closeToast }) => (
      <BulkAction<WorkspaceAccount>
        actionFn={actionFn}
        items={accounts}
        onClose={closeToast}
        renderTitle={renderToastTitle}
        isAsync={isAsync}
        renderReviewItem={(account) => (
          <div className="flex border border-black-200 p-3 gap-x-2 rounded-3xl">
            <AccountProfileImage account={account} />
            <div className="flex flex-col gap-y-0.5">
              <AccountName account={account} className="text-sm-bold" />
              <span className="text-black-500 text-xs-medium">
                {account.occupation}
              </span>
            </div>
          </div>
        )}
      />
    ),
    {
      position: "bottom-right",
      autoClose: false,
      closeButton: false,
      icon: false,
    },
  );
}
